import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { AnimationService } from '../../core/ui/animation.service';
import { styleVariables } from '../../styles/variables';

export interface CursorSelectionDef {
  fromX: number;
  fromY: number;
  toX: number;
  toY: number;
  visible: boolean;
}

@Component({
  selector: 'pg-calendar-cursor, grit-calendar-cursor',
  templateUrl: './pg-calendar-cursor.component.html',
  styleUrls: ['./pg-calendar-cursor.component.scss'],
  exportAs: 'pgCalendarCursor, gritCalendarCursor',
})
export class PgCalendarCursorComponent implements OnInit, OnChanges {
  @ViewChild('cursor', { static: true })
  _cursorChild: ElementRef;
  get cursorEl() {
    return this._cursorChild.nativeElement;
  }

  visible = false;
  xPos = 0;
  yPos = 0;

  duration = 200;

  @Input()
  cellSize: number;

  constructor(
    private _animationService: AnimationService,
    private _renderer: Renderer2
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {}

  show() {
    if (this.visible) {
      return Promise.resolve();
    }
    return this._animationService
      .animate({
        targets: this.cursorEl,
        transform: [`scale(0.64)`, `scale(1)`],
        opacity: [0, 1],
        duration: this.duration,
        easing: styleVariables.transitionCurveDeceleration,
      })
      .then(() => {
        this.visible = true;
        this._renderer.setStyle(this.cursorEl, 'opacity', 1);
      });
  }

  hide() {
    if (!this.visible) {
      return Promise.resolve();
    }
    return this._animationService
      .animate({
        targets: this.cursorEl,
        transform: [`scale(1)`, `scale(0.64)`],
        opacity: [1, 0],
        duration: this.duration,
        easing: styleVariables.transitionCurveAcceleration,
      })
      .then(() => {
        this.visible = false;
        this._renderer.setStyle(this.cursorEl, 'opacity', 0);
      });
  }

  moveTo(x, y) {
    return this._animationService
      .animate({
        targets: this.cursorEl,
        left: x,
        top: y,
        opacity: 1,
        duration: this.duration,
      })
      .then(() => {
        this.xPos = x;
        this.yPos = y;
        this._renderer.setStyle(this.cursorEl, 'left', `${x}px`);
        this._renderer.setStyle(this.cursorEl, 'top', `${y}px`);
      });
  }

  setPosition(x, y) {
    this.cursorEl.style.left = x + 'px';
    this.cursorEl.style.top = y + 'px';
    this.xPos = x;
    this.yPos = y;
    return Promise.resolve();
  }
}
